import {MenuItem} from '@/store/types';
import {RouteConfig} from 'vue-router';

export function menu (): MenuItem[] {
    return [
        {
            title: 'Autorización',
            icon: 'mdi-security',
            permission: '@/authorization/admin/administration_access',
            requireAuthorization: true,
            children: [
                {
                    title: 'Permisos de usuario',
                    icon: 'mdi-format-list-numbered',
                    routeName: 'authorization.permissions',
                    requireAuthorization: true,
                    // Este permiso otorga acceso a la pantalla de permisos de usuario
                    permission: '@/authorization/admin/permissions/permission_administration_access',
                },
                {
                    title: 'Roles de usuario',
                    icon: 'mdi-account-multiple',
                    routeName: 'authorization.roles',
                    requireAuthorization: true,
                    // Este permiso otorga acceso a la pantalla de roles de usuario
                    permission: '@/authorization/admin/role/role_detail_access',
                },
            ],
        },
    ]
}

/**
 * Rutas del módulo
 */
export function routes (): RouteConfig[] {
    return [
        {
            name: 'authorization.permissions',
            path: '/autorización/permisos',
            component: () => import(/* webpackChunkName: "permission-master.component" */ '@/modules/authorization/components/PermissionsMaster.vue'),
            meta: {
                authRequired: true,
                toolbarTitle: 'Permisos de usuario',
                module: 'authorization',
            },
            children: [
                {
                    name: 'authorization.permissionDetail',
                    path: ':id',
                    component: () => import(
                        /* webpackChunkName: "permission-detail.component" */'@/modules/authorization/components/PermissionDetail.vue'),
                    meta: {
                        authRequired: true,
                        toolbarTitle: 'Ver/editar permiso',
                    },
                },
            ],
        },
        {
            name: 'authorization.roles',
            path: '/autorización/roles',
            component: () => import(
                /* webpackChunkName: "role-master.component" */ '@/modules/authorization/components/RoleMaster.vue'),
            meta: {
                authRequired: true,
                toolbarTitle: 'Administración de roles',
                module: 'authorization',
            },
        },
    ]
}
